//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReportFormat, ReportStatus } from './Enums';

export class ReportSearchOptions extends ItemBase {
    IDs: string[] = [];
    AutoDelete: boolean | null = null;
    ReportFormats: ReportFormat[] = [];
    ReportStatuses: ReportStatus[] = [];
    SearchText: string | null = null;
    Archived: boolean | null = null;

    constructor(initializer?: Partial<ReportSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ReportSearchOptions";
}
